import { Helmet } from "react-helmet";
import React from "react";
import { LAST_TIME_YOU_STILL_CAN_BOOK } from "./useConstants";

const MetaTags = ({
  title = "My Laundry",
  description = `My Laundry is your professional laundry service and shoe cleaning service in Bangkok. We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by 12:00 the next day - fast & easy! Createan order now!`,
}) => {
  return (
    <Helmet>
      <meta charset="utf-8" />
      <link rel="icon" href={`./favicon.png`} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#000000" />
      <meta name="description" content={description} />
      <meta name="og:title" content={title} />
      <meta name="og:description" content={description} />
      <meta name="og:image" content={`./favicon.png`} />
      <meta name="og:url" content={`./favicon.png`} />
      <meta name="og:type" content="website" />
      <meta name="og:site_name" content={title} />
      <meta name="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content={title} />
      <meta name="twitter:creator" content="@My Laundry" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`./favicon.png`} />
      <link rel="apple-touch-icon" href={`./favicon.png`} />
      <title>{title}</title>
    </Helmet>
  );
};

export default MetaTags;
